import { render, staticRenderFns } from "./CustomerSwitcher.vue?vue&type=template&id=24c4ff60&scoped=true"
import script from "./CustomerSwitcher.vue?vue&type=script&lang=js"
export * from "./CustomerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CustomerSwitcher.vue?vue&type=style&index=0&id=24c4ff60&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4ff60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c4ff60')) {
      api.createRecord('24c4ff60', component.options)
    } else {
      api.reload('24c4ff60', component.options)
    }
    module.hot.accept("./CustomerSwitcher.vue?vue&type=template&id=24c4ff60&scoped=true", function () {
      api.rerender('24c4ff60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopNav/CustomerSwitcher.vue"
export default component.exports